import api from "./client";

// список
export const getIncidents = () =>
  api.get("/api/incidents/");

// один
export const getIncident = (id) =>
  api.get(`/api/incidents/${id}/`);

// создать
export const createIncident = (data) =>
  api.post("/api/incidents/", data);

// отправить
export const sendIncident = (id) =>
  api.post(`/api/incidents/${id}/send/`);

// аналитика
export const getIncidentStats = () =>
  api.get("/api/incidents/stats/");

export const updateIncident = (id, data) =>
  api.put(`/api/incidents/${id}/`, data);

export const deleteIncident = (id) =>
  api.delete(`/api/incidents/${id}/`);

// Каталог диагнозов для формы опасного инфекционного заболевания
export const getIncidentDiagnoses = (lang = "tj") =>
  api.get(`/api/incidents/diagnoses/?lang=${encodeURIComponent(lang)}`);

// Скачать PDF-форму экстренного извещения об инфекционном заболевании
export const downloadIncidentPdf = (id) =>
  api.get(`/api/incidents/${id}/pdf/`, { responseType: "blob" });
